import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import logoNotenetic from "../../assets/images/logo_notenetic.png";
import DEVELOPMENT_CONFIG from "./../../helper/config";
function Footer() {

   const staffLoginInfo = useSelector((state) => state?.getStaffReducer);
   const storageAppVersion= localStorage.getItem(DEVELOPMENT_CONFIG.APP_VERSION);
   const state = useSelector(states => {
    return states;
  });

   const { appIsImpersonate } = state['LoggedInReducer'];

   useEffect(() => {
      if(!appIsImpersonate ){
        const script = document.createElement("script");
        script.src = "https://fw-cdn.com/10965965/3723596.js";
        script.setAttribute("chat", "true");
        document.body.appendChild(script);
        return () => {
          document.body.removeChild(script);
        };
      }
    }, [appIsImpersonate]);
    
    useEffect(() => {
      if (staffLoginInfo) {
        const checkFwcrm = setInterval(() => {
          if (window.fwcrm) {
            clearInterval(checkFwcrm);
            window.fwcrm.on("widget:loaded", function () {
              window.fcWidget.conversation.setBotVariables({
                ProviderId: `${staffLoginInfo.clinicId}`,
                ProviderName: `${staffLoginInfo.clinicName}`,
                StaffFirstName: `${staffLoginInfo.firstName}`,
                StaffLastName: `${staffLoginInfo.lastName}`,
                StaffEmail: `${staffLoginInfo.email}`,
                cf_username: `${staffLoginInfo.userName}`,
                cf_clinic: `${staffLoginInfo.clinicId} - ${staffLoginInfo.clinicName}`,
              });
            });
          }
        }, 100);
        window.fcSettings = {
          onInit: function () {            
            window.fcWidget.user.setFirstName(`${staffLoginInfo.firstName}`);
            window.fcWidget.user.setLastName(`${staffLoginInfo.lastName}`);
            window.fcWidget.user.setEmail(`${staffLoginInfo.email}`);
            window.fcWidget.user.setProperties({
              cf_username: `${staffLoginInfo.userName}`,
              cf_clinic: `${staffLoginInfo.clinicId} - ${staffLoginInfo.clinicName}`
            });
          },
        };
      }
    }, [staffLoginInfo]);

 return (
    <div>
 
 <footer className='footer-main'>
 <div className="container">

     <h1 className="logo-link notenetic-text text-center pb_5">
     <img src={logoNotenetic} />
     </h1>
     <div className="row ptb_40">
        <div className='col-lg-4 col-md-4 col-12'>
         <h4 className='address-title text-grey mb-2'><span className='f-24'>About Notenetic</span></h4>
         <p className = 'f-16 text-grey' > Notenetic is an entirely web - based solution created to streamline and manage your data and documentation. Notenetic is designed to be a user - friendly interface, providing you with secure and convenient access to your vital data and documents from anywhere with an internet connection. Discover a smarter way to organize, search, and manage your digital content with Notenetic.</p>
        </div>
        {/*End*/}
        {/* <div className='col-lg-2 col-md-6 col-12'> */}
       {/* <div className='d-flex flex-wrap pt_30'> */}
         {/* <div className='address-column d-flex align-items-center col-md-6 col-12 mb-3'>
            <span className="fa fa-phone circle-rouned"></span>
         <div className='content-footer pl-2'>
             <p className='mb-0 f-14'>Phone number</p>
             <p className='fw-bold mb-0 f-16'>+1 234 56 78 123</p>
         </div>
         </div> */}
         {/*End*/}
         {/* <div className='address-column d-flex align-items-center col-md-6 col-12 mb-3'>
            <span className="k-icon k-i-email circle-rouned"></span>
         <div className='content-footer pl-2'>
             <p className='mb-0 f-14'>Email</p>
             <p className='fw-bold mb-0 f-16'>info@notenetic.com</p>
         </div>
         </div> */}
         {/*End*/}
         {/* <div className='address-column d-flex align-items-center col-md-6 col-12  mb-3'>
            <span className="fa fa-fax circle-rouned"></span>
         <div className='content-footer pl-2'>
             <p className='mb-0 f-14'>Fax</p>
             <p className='fw-bold mb-0 f-16'>+1 234 56 78 123</p>
         </div>
         </div> */}
         {/*End*/}
         {/* <div className='address-column d-flex align-items-center col-md-6 col-12 mb-3'>
            <span className="k-icon k-i-marker-pin circle-rouned"></span>
         <div className='content-footer pl-2'>
             <p className='mb-0 f-14'>Location</p>
             <p className='fw-bold mb-0 f-16'>49, Caradon Hill, ULBSTER</p>
         </div>
         </div> */}
         {/*End*/}
       {/* </div> */}
        {/* </div> */}
        {/*End*/}
        {/* <div className='col-lg-2 col-md-6 col-12'>

        </div> */}
        {/*End*/}
        <div className='col-lg-2 col-md-6 col-12'>         
        <h4 className='address-title text-grey mb-2'><span className='f-24'>Quick Access</span></h4>
          <ul className='list-unstyled'>
             <li className='mb-2'><a href='/dashboard' className="text-grey f-16 text-decoration-none">Dashboard</a></li>
             <li className='mb-2'><a href='/document/list' className="text-grey f-16 text-decoration-none">Documents</a></li>
             <li className='mb-2'><a href='/client/list' className="text-grey f-16 text-decoration-none">Clients</a></li>
          </ul>
        </div>
        {/*End*/}
     </div>
     <div className='border-bottom'></div>
     <div className='ptb_30'>
         <p className='text-center f-16 text-grey mb-0'> {`Notenetic All rights reserved Copyright`} {new Date().getFullYear()}</p>
         <p className='text-center f-16 text-grey mb-0'> {`Version ${storageAppVersion}`}</p>
     </div>
 </div>
</footer>
</div>
);
 }
 export default Footer;
